import { render, staticRenderFns } from "./viewLessonDetai.vue?vue&type=template&id=6c49ab35&scoped=true&"
import script from "./viewLessonDetai.vue?vue&type=script&lang=js&"
export * from "./viewLessonDetai.vue?vue&type=script&lang=js&"
import style0 from "./viewLessonDetai.vue?vue&type=style&index=0&id=6c49ab35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c49ab35",
  null
  
)

export default component.exports